import { render, staticRenderFns } from "./Complains.vue?vue&type=template&id=f47ea6c8&"
import script from "./Complains.vue?vue&type=script&lang=js&"
export * from "./Complains.vue?vue&type=script&lang=js&"
import style0 from "./Complains.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports